<div class="app-overlay" (click)="onBackdropClick()">
  <div class="app-overlay-content" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
  </div>
</div>
